import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const QRCode = createSvgIcon(
  <path d="M0 9.75h9.75V0H0v9.75Zm2.25-7.5H7.5V7.5H2.25V2.25Zm12-2.25v9.75H24V0h-9.75Zm7.5 7.5H16.5V2.25h5.25V7.5Zm-1.5 9.75H18l-.075-3H14.25V18h3v2.25h-3V24H18v-3h2.25v3H24v-3.75h-3V18h3v-3.75h-3.75v3ZM0 24h9.75v-9.75H0V24Zm2.25-7.5H7.5v5.25H2.25V16.5Z" />,
  'QRCode'
);

export { QRCode };
